import type { IconComponent } from "./types";

export const Apple: IconComponent = ({ ref, color = "currentColor", ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 24" ref={ref} {...props}>
      <title>Apple</title>
      <path
        fill="#000"
        d="M13.05 5.54a4.7 4.7 0 0 0 3.25-1.71A5.45 5.45 0 0 0 17.57.47c0-.16-.01-.33-.04-.47-1.21.05-2.66.8-3.53 1.83-.69.78-1.31 2-1.31 3.25 0 .18.03.37.04.43.08.01.2.03.32.03ZM9.24 24c1.48 0 2.14-1 3.98-1 1.88 0 2.3.97 3.94.97 1.62 0 2.7-1.5 3.72-2.96 1.15-1.68 1.62-3.33 1.65-3.4-.1-.03-3.2-1.3-3.2-4.85 0-3.09 2.44-4.48 2.57-4.58a5.65 5.65 0 0 0-4.74-2.38c-1.82 0-3.3 1.1-4.23 1.1-1 0-2.33-1.04-3.9-1.04C6.03 5.86 3 8.33 3 13c0 2.9 1.13 5.96 2.52 7.95C6.7 22.63 7.75 24 9.24 24Z"
      />
    </svg>
  );
};
Apple.displayName = "Apple";
